/* eslint-disable react/prop-types */ // TODO: add props
import SelfMarkQuestion from './SelfMarkQuestion';
import SampleMarkQuestion from './SampleMarkQuestion';

const IntegerQuestion = (props) => {
  if (props.question.get('question_to_review')) {
    return <SelfMarkQuestion {...props} />;
  }
  return <SampleMarkQuestion {...props} />;
};

export default IntegerQuestion;
